module.exports = ['$utils', '$q', 'Message', 'User', 'globalFolderService',
  function ($utils, $q, Message, User, globalFolderService) {
    function SearchMailFolder(iId, sOrder, oFilter) {
      this.id = iId
      this.filter = oFilter
      this.order = sOrder
      this.messages = []
      this.stats = { unreadMessageCount: 0 }
      this.type = 'virtualFolder'
      this.filterFlags = {
      }
    }

    SearchMailFolder.prototype.loadMessages = function(oFilter, sOrder, fids, iStart, iLimit) {
      const self = this
      const filterFids = { '-2': 'unReadFolderIds', '-3': 'flaggedFolderIds', '-5': 'deferHandleFolderIds' }
      if (filterFids[self.id]) {
        fids = globalFolderService.getCacheFolderData(filterFids[self.id])
      }
      iStart = iStart || 0
      iLimit = iLimit || 20
      return User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:listMessages',
          sid: User.getCurrentUser().sid
        },
        data: {
          fids: fids,
          mode: 'count',
          order: sOrder || 'receivedDate',
          desc: true,
          start: iStart,
          limit: iLimit,
          summaryWindowSize: iLimit,
          filter: oFilter,
          skipLockedFolders: true,
          topFirst: true,
          returnTotal: true,
          filterFlags: self.filterFlags,
          mboxa: User.getSelectedAccountSymbol()
        }
      })
    }
    SearchMailFolder.prototype.fetchMessages = function (iStart, iLimit) {
      const self = this
      const deferred = $q.defer()

      self.loadMessages(self.filter, self.order, self.fids || [], iStart, iLimit).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          const messages = data['var'] ? Message.buildMessages(data['var']) : []
          self.totals = data.total ? data.total : 0
          self.messages = messages
          deferred.resolve(messages)
        } else {
          deferred.reject(code)
        }
      }, function (error) {
        console.debug('fetchmessage: ' + JSON.stringify(error))
        deferred.reject(error)
      })

      return deferred.promise
    }
    // 获取当前邮件的前后加自身共三封邮件用于单点读信的前后页切换
    SearchMailFolder.prototype.getBeforeAfterMessages = function (fids, start, mid, flags) {
      return User.getCurrentUser().simpleCall({
        query: {
          func: 'mbox:listMessages',
          sid: User.getCurrentUser().sid
        },
        data: {
          fids: fids,
          filter: {flags: flags},
          order: 'receivedDate',
          desc: true,
          start: start,
          limit: 3,
          returnTotal: true,
          offsetmid: mid
        }
      }).then(function (data) {
        if (data.code !== 'S_OK') return $q.reject(data)

        return Message.buildMessages(data.var || [])
      })
    }
    SearchMailFolder.prototype.loadMoreMessages = function (iStart) {
      const self = this
      const deferred = $q.defer()

      if (self.messages[iStart]) {
        deferred.resolve(self.messages.slice(iStart, iStart + 20))
        return deferred.promise
      }

      self.loadMessages(self.filter, self.order, self.fids || [], iStart).then(function (data) {
        const code = data.code
        if (code == 'S_OK') {
          const messages = Message.buildMessages(data['var'])
          self.messages = self.messages.concat(messages)
          self.totals = data.total ? data.total : 0
          if (messages.length > 0) {
            self.latestMessageTime = messages[0]['sentDate']
            self.eariestMessageTime = messages[messages.length - 1]['sentDate']
          }

          deferred.resolve(messages)
        } else {
          deferred.reject(code)
        }
      }, function (code) {
        console.debug('loadmore: ' + JSON.stringify(code))
        deferred.reject(code)
      })

      return deferred.promise
    }

    SearchMailFolder.prototype.removeMessages = function (aMessages, mboxa) {
      if (aMessages && aMessages.length > 0) {
        const message = new Message()
        const deferred = message.remove(aMessages, mboxa)
        for (let i = 0; i < aMessages.length; ++i) {
          for (let j = 0; j < this.messages.length; ++j) {
            if (aMessages[i].messageInfo.id == this.messages[j].messageInfo.id) {
              this.messages.splice(j, 1)
              this.totals--
            }
          }
        }
        return deferred
      }
    }

    /** todo: moveMsgsToFolder 和 removeMessages 逻辑可重构 */
    SearchMailFolder.prototype.moveMsgsToFolder = function (aMessages, oFolder, mboxa) {
      if (aMessages && aMessages.length > 0) {
        const message = new Message()
        const deferred = message.moveToFolder(aMessages, oFolder, mboxa)
        for (let i = 0; i < aMessages.length; ++i) {
          for (let j = 0; j < this.messages.length; ++j) {
            if (aMessages[i].messageInfo.id == this.messages[j].messageInfo.id) {
              this.messages.splice(j, 1)
              this.totals--
            }
          }
        }
        return deferred
      }
    }

    SearchMailFolder.prototype.getMessages = function () {
      return this.messages
    }

    return SearchMailFolder
  }]



// WEBPACK FOOTER //
// ./src/js/mail/SearchMailFolder.js